<template>
  <div class="no-permission f ai-c jc-c">
    <img src="../assets/no-permission.png" alt="">
  </div>
</template>

<script>
export default {
  name: "noPermission"
}
</script>

<style scoped>
.no-permission{
  width: 100%;
  height: 100%;
}
</style>